"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildEnv = void 0;
exports.buildEnv = {
    buildMode: 'release',
    sdkVersion: '3.11.0',
};
//# sourceMappingURL=buildEnv.js.map